export default {
    _prefix: "AssistanceStatus",
    status: {
        questionCount: {
            singleQuestion: (data: { count: number }) => {
                return "{{count}} question answered";
            },
            multipleQuestions: (data: { count: number }) => {
                return "{{count}} questions answered";
            },
        },
        tooltipText: (data: {
            answeredQuestionCount: number;
            totalQuestionCount: number;
        }) => {
            return "Evaluation Assistance successfully answered {{answeredQuestionCount}} of {{totalQuestionCount}} questions";
        },
    },
};
